import type { AccessorialDetailsApi, AccessorialDetailsParams, SortingOptions } from '../models';

const accessorialDetails = Array.from({ length: 50 }, (_, i) => ({
  actualClass: '23989389383',
  baseRate: 0,
  calculationType: 'Text text',
  discount: 0,
  discountCalculationType: 'Text text',
  id: `${i + 1}`,
  laneId: '23989389383',
  range1: { from: '31-Dec-2025', measurement: 'Text text', to: '31-Dec-2025', type: 'Text text' },
})) satisfies AccessorialDetailsApi['items'];

export const fetchAccessorialDetails = (
  params: AccessorialDetailsParams,
  _options: { signal?: AbortController['signal'] } = {},
) =>
  Promise.resolve({
    data: accessorialDetails.slice(params.offset, params.offset + params.limit),
    total: accessorialDetails.length,
  });

export const fetchSortingOptions = (_options: { signal?: AbortController['signal'] } = {}): Promise<SortingOptions> => {
  return Promise.resolve([
    { id: 'date-newest', label: 'Sort by Date (Newest to Oldest)', value: 'date-newest' },
    { id: 'date-oldest', label: 'Sort by Date (Oldest to Newest)', value: 'date-oldest' },
  ]);
};
